import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

export default function LandingPage() {
  return (
    <div className="ui-tab-page bg-white">
      <HeroSection />
      <FeaturesSection />
      <PricingSection />
      <TestimonialsSection />
      <ContactSection />

      {/* Footer */}
      <footer className="bg-gray-800 px-6 py-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-3">
          <div className="w-7 h-7 rounded-lg bg-green-600 flex items-center justify-center flex-shrink-0">
            <i className="ri-leaf-line text-white text-sm"></i>
          </div>
          <span className="text-white font-bold text-base">finfins</span>
        </div>
        <p className="text-gray-400 text-xs mb-4 leading-relaxed">
          The modern green cleaning management platform<br />built for eco-conscious teams that move fast.
        </p>
        <div className="flex items-center justify-center gap-4 mb-5">
          {['ri-twitter-x-line', 'ri-linkedin-box-line', 'ri-facebook-box-line', 'ri-youtube-line'].map((icon) => (
            <a key={icon} href="#" rel="nofollow" className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center cursor-pointer">
              <i className={`${icon} text-gray-300 text-sm`}></i>
            </a>
          ))}
        </div>
        <div className="border-t border-gray-700 pt-4">
          <p className="text-gray-500 text-[10px]">
            &copy; {new Date().getFullYear()} finfins · Privacy Policy · Terms of Service
          </p>
        </div>
      </footer>
    </div>
  );
}
